export default "__VITE_ASSET__DvsMON0K__"